<template>
  <el-dialog
    :title="shopName"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    width="70%"
  >
    <span>{{ selectPara.startDate }} ~ {{ selectPara.endDate }}</span>
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
    >
      <el-table-column :label="$t('Name')">
        <template slot-scope="scope">
          {{ field(scope.row.Name) }}
        </template>
      </el-table-column>
      <el-table-column prop="Number" label="数量"></el-table-column>
      <el-table-column prop="Total" label="合计">
        <template slot-scope="scope">
          <span class="text_red">${{ scope.row.Total }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import util from "util/date";
import { getSalesDetailList } from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      list: [],
      listLoading: false,
      dialogVisible: false,
      selectPara: {},
      shopName: "",
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    //获取列表
    getList() {
      this.listLoading = true;
      getSalesDetailList(this.selectPara).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    loadData(id, name, startDate, endDate) {
      this.shopName = name;
      this.selectPara = {
        shopId: id,
        startDate: startDate,
        endDate: endDate,
      };
      this.getList();
      this.dialogVisible = true;
    },
  },
};
</script>
